import { Menu } from "lucide-react";

const ProfileHeader = ({onMenuClick,val='Profile Setting'}) => {
  return (
    <div className="support-header">
      <Menu className="menu-btn " onClick={onMenuClick} />
      <div>
         <h1>{val}</h1>
         <p>Get help and find answers to your questions</p>
    </div>
    </div>
  );
};

export default ProfileHeader;
